import React from 'react';
import { FiMail } from 'react-icons/fi';
import styles from './RequestAccess.module.css';
import * as utils from '../../utils/utils';
import validator from 'validator';

export default class RequestAccess extends React.Component {
    constructor(props) {
        super(props);

        // State initialization
        this.state = {
            email: '',
            isSubmitting: false,
            successText: '',
            errorText: '',
        };
    };

    handleEmailChange = (event) => {
        this.setState({
            email: event.target.value,
            errorText: '',
            successText: '',
        });
    };

    handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            this.onRequestAccess();
        }
    };

    onRequestAccess = async () => {
        if (this.state.isSubmitting) {
            return;
        }

        const normalizedEmail = String(this.state.email || '').trim().toLowerCase();

        if (normalizedEmail === '' || !validator.isEmail(normalizedEmail)) {
            this.setState({
                setErrorText: 'Please enter your email.', // or errorText: 'Please enter your email.'
                errorText: 'Please enter your email.',
                successText: '',
            });
            return;
        }

        this.setState({
            isSubmitting: true,
            errorText: '',
            successText: '',
        });

        try {
			await utils.sendRequest('/requestAccess/requestAccess', {
				email: normalizedEmail,
			});

            this.setState({
                email: '',
                successText: 'Request submitted!',
            });
        } catch (error) {
            this.setState({
                errorText: error?.message || 'Could not submit your request right now.',
            });
        } finally {
            this.setState({
                isSubmitting: false,
            });
        }
    };

    render() {
        const { email, isSubmitting, successText, errorText } = this.state;

        return (
            <div className={styles.pageContainer}>
                <div className={styles.glowLayer}>
                    <div className={styles.glowTop} />
                    <div className={styles.glowBottom} />
                </div>

                <div className={styles.layoutShell}>
                    <section className={styles.cardPanel}>
                        <div className={styles.sectionHeader}>
                            <h2 className={styles.formTitle}>
                                <FiMail /> Request Access
                            </h2>
                            <p className={styles.formText}>
                                Join HQ and unlock tools built for focused career growth.
                            </p>
                        </div>

                        <div className={styles.whySection}>
                            <h3 className={styles.whyTitle}>Why HQ</h3>
                            <p className={styles.whyBody}>
                                HQ is completely different than any other professional network.
                                The only thing that matters on HQ is YOU!
                                What you are building, learning, or working on.
                                <br />
                                <br />
                                People on HQ don't write AI-generated slop. We focus on real, and raw contributions such as:
                                "I learned about a new technology today" or "I built a new feature for my project."
                                <br />
                                <br />
                                We also don't believe in charging our users for the smallest things like who viewed your profile, or who you should connect with.
                                <br />
                                In fact, HQ doesn't even have a concept of sending connection requests. It's all autonomous.
                                <br />
                                <br />
                                We are bringing something completely different from anything you have seen before!
                                A completely fresh, new way to professionally network with like-minded individuals, mentors, and people who potentially could get you ahead in your career.
                                <br />
                                <br />
                                We are bringing In-Real-Life interactions online!
                                <br />
                                <br />
                                Join us and experience a new era of professional networking.
                            </p>
                            {/* <p className={styles.whyBody}>
                                You've probably noticed your feed is drowning in AI-generated fluff and hot takes.
                                <br />
                                Every day, it's the same noise: "SaaS is dead...", "OpenAI just changed everything...", "Claude did X..." - usually written by people who have never launched a SaaS product nor worked at these companies, just regurgitating news for views.
                                <br /><br />
                                Does any of that actually add value to your day? No.
                                <br />
                                If we wanted news, we'd get it straight from the source - not from recycled engagement bait by random influencers.
                                <br /><br />
                                What we need is a high-signal professional network where YOU talk about what you are building, learning, and doing.
                                <br />
                                A network to learn from each other, and grow together.
                                <br /><br />
                                This is why we're building HQ.<br />
                                The slop problem is only a small part of what we're fixing at HQ.
                                <br />
                                HQ is all and only about you - talk and brag about what YOU are doing.
                                <br /><br />
                                And before you ask: No, we don't use your content to train AI models. We don't sell your data. We don't sell ads. We don't sell anything. We just want to build a high-signal network that brings real value to you and your career.
                                <br /><br />
                                Join us and let's build a high-signal network that brings real value.
                            </p> */}
                        </div>

                        <div className={styles.contentSection}>
                            <div className={styles.inputWrapper}>
                                <label className={styles.inputLabel} htmlFor="request-access-email">
                                    Email
                                </label>
                                <input
                                    id="request-access-email"
                                    type="text"
                                    value={email}
                                    onChange={this.handleEmailChange}
                                    className={styles.input}
                                    placeholder="you@example.com"
                                    autoComplete="email"
                                    onKeyDown={this.handleKeyDown}
                                />
                            </div>

                            {errorText !== '' && <div className={styles.errorBox}>{errorText}</div>}
                            {successText !== '' && <div className={styles.successBox}>{successText}</div>}

                            <button
                                type="button"
                                className={styles.primaryButton}
                                onClick={this.onRequestAccess}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Submitting...' : 'Request Access'}
                            </button>
                        </div>
                    </section>
                </div>
            </div>
        );
    };
}